import { maybeLog } from '../utils';

/**
 * Intended to be triggered when a user visits a page on the webapp.
 */
export async function handlePageView( config ) {
    const debug = Boolean( config?.debug );
    const pageTitle = config?.title ? config.title : 'Unknown';
    const pageUrl = config?.path ? config.path : document.location.pathname;

    maybeLog( debug, `Viewing page '${ pageTitle }' at '${ pageUrl }'` );

    // ...
}
